<template>
  <select class="form-control" name="html_behaviour" id="html_behaviour" @change="onChange($event)">
    <option value="replace_text" :selected="selectedValue == 'replace_text'" >HTML sustituye al texto</option>
    <option value="align_left" :selected="selectedValue == 'align_left'" >HTML alineado a la izquierda del texto</option>
  </select>
</template>

<script>
export default {
  name: 'html-behaviour',
  emits: ['update'],
  props: {
    selectedValue : {
      type: String
    }
  },
  data () {
    return {
      value : '',
    };
  },
  methods: {
    onChange(event) {
      let optionSelected = event.target.value;
      this.value = optionSelected;
      this.$emit('update', optionSelected);
    }
  }
}
</script>
